import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { AdminAuthGuard } from '@/components/layout/AdminAuthGuard';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { UsersPage } from '@/pages/UsersPage';
import { UserDetailPage } from '@/pages/UserDetailPage';
import { RevenuePage } from '@/pages/RevenuePage';
import { SettingsPage } from '@/pages/SettingsPage';
import { SeoPage } from '@/pages/SeoPage';
import { BlogPage } from '@/pages/BlogPage';
import { PaymentsPage } from '@/pages/PaymentsPage';
import { StrategiesPage } from '@/pages/StrategiesPage';
import { BacktestPage } from '@/pages/BacktestPage';
import { BotsPage } from '@/pages/BotsPage';
import { ReferralPage } from '@/pages/ReferralPage';
import { AnalyticsPage } from '@/pages/AnalyticsPage';
import { ThreadsMonitorPage } from '@/pages/ThreadsMonitorPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <AdminAuthGuard />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <Navigate to="/dashboard" replace /> },
          { path: '/dashboard', element: <DashboardPage /> },
          { path: '/analytics', element: <AnalyticsPage /> },
          { path: '/users', element: <UsersPage /> },
          { path: '/users/:id', element: <UserDetailPage /> },
          { path: '/revenue', element: <RevenuePage /> },
          { path: '/payments', element: <PaymentsPage /> },
          { path: '/blog', element: <BlogPage /> },
          { path: '/strategies', element: <StrategiesPage /> },
          { path: '/backtests', element: <BacktestPage /> },
          { path: '/bots', element: <BotsPage /> },
          { path: '/referrals', element: <ReferralPage /> },
          { path: '/threads', element: <ThreadsMonitorPage /> },
          { path: '/seo', element: <SeoPage /> },
          { path: '/settings', element: <SettingsPage /> },
        ],
      },
    ],
  },
]);
